<script setup lang="ts">
import { Progress } from '@/components/ui/progress';
import { Skeleton } from '@/components/ui/skeleton';

withDefaults(defineProps<{
    label?: string;
    value?: number;
    loading?: boolean;
    loadingLabel?: string;
    emptyLabel?: string;
    limitReached?: boolean;
    limitReachedLabel?: string;
    compact?: boolean;
    indicatorColor?: string;
    trackColor?: string;
}>(), {
    label: '',
    value: 0,
    loading: false,
    loadingLabel: 'Loading usage…',
    emptyLabel: 'Usage is not available.',
    limitReached: false,
    limitReachedLabel: 'limit reached',
    compact: false,
    indicatorColor: '',
    trackColor: '',
});
</script>

<template>
    <div :class="compact ? 'space-y-1.5' : 'mt-3 max-w-md space-y-2'" aria-live="polite">
        <Skeleton v-if="loading" :class="compact ? 'h-1.5 w-full rounded-full' : 'h-2 w-full rounded-full'" />
        <Progress
            v-else-if="label"
            :model-value="Math.min(100, Math.max(0, value))"
            :class="compact ? 'h-1.5' : undefined"
            :indicator-color="indicatorColor"
            :track-color="trackColor"
        />
        <p class="text-xs text-muted-foreground">
            {{ loading ? loadingLabel : (label || emptyLabel) }}
            <span v-if="!loading && limitReached" class="text-destructive"> · {{ limitReachedLabel }}</span>
        </p>
    </div>
</template>
